import { required } from 'vuelidate/lib/validators'
import Agency from '@/models/Agency'
import User from '@/models/User'

export default {
    fields: {
        agency_id: {
            label: 'Agency',
            type: 'select',
            options: [],
            async loadOptions (model) {
                Agency.loadAgencyOptions(this)
            },
            validations: { required }
        },
        user_id: {
            label: 'User',
            type: 'typeahead',
            options: [],
            async loadOptions (model) {
                User.loadUserOptions(this)
            },
            validations: { required }
        },
        is_program_admin: {
            label: 'Is Program Admin',
            type: 'check'
        },
        is_owners_representative: {
            label: 'Is Owners Rep',
            type: 'check'
        },
        is_project_manager: {
            label: 'Is Project Manager',
            type: 'check'
        },
        department: {
            label: 'Dept. / Bureau',
            type: 'text'
        },
        company_name: {
            label: 'Company Name',
            type: 'text'
        },
        //  other fields
        user_full_name: {
            label: 'User Name',
            type: 'text'
        },
        agency_name: {
            label: 'Agency Name',
            type: 'text'
        },
    },
}
